import { CADStyle, LineType } from '@technology/web3d-plugin-line-editing';
import type { LayerLineStyle, LayerStyle } from '../types/layer-template';

const POINT_LINE_WIDTH = 2;
const LINE_WIDTH = 2;
const POINT_SIZE = 10;

const LINE_TYPE_BY_STYLE: Record<LayerLineStyle, LineType> = {
  solid: LineType.Solid,
  dashed: LineType.Dashed,
  dotted: LineType.Dotted,
};

export function createPointCadStyle(
  layerStyle: LayerStyle | undefined,
  fallbackColor: string
): CADStyle {
  return new CADStyle(
    layerStyle?.color ?? fallbackColor,
    POINT_LINE_WIDTH,
    LineType.Solid,
    POINT_SIZE
  );
}

export function createLineCadStyle(
  layerStyle: LayerStyle | undefined,
  fallbackColor: string
): CADStyle {
  return new CADStyle(
    layerStyle?.color ?? fallbackColor,
    layerStyle?.lineWeight ?? LINE_WIDTH,
    layerStyle?.lineStyle
      ? LINE_TYPE_BY_STYLE[layerStyle.lineStyle]
      : LineType.Solid
  );
}
